import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('inv_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res.data,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('inv_token');
      localStorage.removeItem('inv_user');
      window.location.href = '/login';
    }
    return Promise.reject(err.response?.data || err);
  }
);

export const authApi = {
  login:          (data) => api.post('/auth/login', data),
  me:             ()     => api.get('/auth/me'),
  updateProfile:  (data) => api.put('/auth/profile', data),
  changePassword: (data) => api.put('/auth/change-password', data),
  uploadAvatar:   (form) => api.post('/auth/avatar', form, { headers: { 'Content-Type': 'multipart/form-data' } }),
  register:       (data) => api.post('/auth/register', data),
  getUsers:       ()     => api.get('/auth/users'),
  deleteUser:     (id)   => api.delete(`/auth/users/${id}`),
  setUserStatus:  (id, status) => api.put(`/auth/users/${id}/status`, { status }),
};

export const itemsApi = {
  getAll: (params) => api.get('/items', { params }),
  getOne: (id) => api.get(`/items/${id}`),
  create: (data) => api.post('/items', data),
  update: (id, data) => api.put(`/items/${id}`, data),
  delete: (id) => api.delete(`/items/${id}`),
  getCategories: () => api.get('/items/meta/categories'),
};

export const vendorsApi = {
  getAll: (params) => api.get('/vendors', { params }),
  getOne: (id) => api.get(`/vendors/${id}`),
  create: (data) => api.post('/vendors', data),
  update: (id, data) => api.put(`/vendors/${id}`, data),
  delete: (id) => api.delete(`/vendors/${id}`),
};

export const clientsApi = {
  getAll: (params) => api.get('/clients', { params }),
  getOne: (id) => api.get(`/clients/${id}`),
  create: (data) => api.post('/clients', data),
  update: (id, data) => api.put(`/clients/${id}`, data),
  delete: (id) => api.delete(`/clients/${id}`),
};

export const purchaseOrdersApi = {
  getAll: (params) => api.get('/purchase-orders', { params }),
  getOne: (id) => api.get(`/purchase-orders/${id}`),
  create: (data) => api.post('/purchase-orders', data),
  update: (id, data) => api.put(`/purchase-orders/${id}`, data),
  delete: (id) => api.delete(`/purchase-orders/${id}`),
  nextNumber: () => api.get('/purchase-orders/meta/next-number'),
};

export const materialIssuesApi = {
  getAll: (params) => api.get('/material-issues', { params }),
  getOne: (id) => api.get(`/material-issues/${id}`),
  create: (data) => api.post('/material-issues', data),
  update: (id, data) => api.put(`/material-issues/${id}`, data),
  delete: (id) => api.delete(`/material-issues/${id}`),
  nextNumber: () => api.get('/material-issues/meta/next-number'),
};

export const dashboardApi = {
  getSummary: () => api.get('/dashboard/summary'),
};
export const mrnApi = {
  getAll:       (params) => api.get('/mrn', { params }),
  getOne:       (id)     => api.get(`/mrn/${id}`),
  create:       (data)   => api.post('/mrn', data),
  updateStatus: (id, data) => api.put(`/mrn/${id}/status`, data),
  delete:       (id)     => api.delete(`/mrn/${id}`),
  nextNumber:   ()       => api.get('/mrn/meta/next-number'),
  getPoItems:   (po_id)  => api.get(`/mrn/po/${po_id}/items`),
};

export const reportsApi = {
  stock:     (params) => api.get('/reports/stock',     { params }),
  purchases: (params) => api.get('/reports/purchases', { params }),
  issues:    (params) => api.get('/reports/issues',    { params }),
  mrn:       (params) => api.get('/reports/mrn',       { params }),
  ledger:    (item_id) => api.get(`/reports/ledger/${item_id}`),
};

export default api;